import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import commonMS from './locales/ms/common.json';
import commonEN from './locales/en/common.json';
import loginMS from './locales/ms/login.json';
import loginEN from './locales/en/login.json';
import studentUniformMS from './locales/ms/studentUniform.json';
import studentUniformEN from './locales/en/studentUniform.json';
import sidebarMS from './locales/ms/sidebar.json';
import sidebarEN from './locales/en/sidebar.json';
import reportsMS from './locales/ms/reports.json';
import reportsEN from './locales/en/reports.json';
import userProfileMS from './locales/ms/userProfile.json';
import userProfileEN from './locales/en/userProfile.json';
import activityManagementMS from './locales/ms/activityManagement.json';
import activityManagementEN from './locales/en/activityManagement.json';
import dashboardMS from './locales/ms/dashboard.json';
import dashboardEN from './locales/en/dashboard.json';
import studentMasterMS from './locales/ms/studentMaster.json';
import studentMasterEN from './locales/en/studentMaster.json';
import userManagementMS from './locales/ms/userManagement.json';
import userManagementEN from './locales/en/userManagement.json';
import systemAuditLogMS from './locales/ms/systemAuditLog.json';
import systemAuditLogEN from './locales/en/systemAuditLog.json';
import uniformDataAuditLogMS from './locales/ms/uniformDataAuditLog.json';
import uniformDataAuditLogEN from './locales/en/uniformDataAuditLog.json';
import issueReportsMS from './locales/ms/issueReports.json';
import issueReportsEN from './locales/en/issueReports.json';
import bulkPromotionMS from './locales/ms/bulkPromotion.json';
import bulkPromotionEN from './locales/en/bulkPromotion.json';

const resources = {
  ms: {
    common: commonMS,
    login: loginMS,
    studentUniform: studentUniformMS,
    sidebar: sidebarMS,
    reports: reportsMS,
    userProfile: userProfileMS,
    activityManagement: activityManagementMS,
    dashboard: dashboardMS,
    studentMaster: studentMasterMS,
    userManagement: userManagementMS,
    systemAuditLog: systemAuditLogMS,
    uniformDataAuditLog: uniformDataAuditLogMS,
    issueReports: issueReportsMS,
    bulkPromotion: bulkPromotionMS
  },
  en: {
    common: commonEN,
    login: loginEN,
    studentUniform: studentUniformEN,
    sidebar: sidebarEN,
    reports: reportsEN,
    userProfile: userProfileEN,
    activityManagement: activityManagementEN,
    dashboard: dashboardEN,
    studentMaster: studentMasterEN,
    userManagement: userManagementEN,
    systemAuditLog: systemAuditLogEN,
    uniformDataAuditLog: uniformDataAuditLogEN,
    issueReports: issueReportsEN,
    bulkPromotion: bulkPromotionEN
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ms', // Default language: Malay
    fallbackLng: 'en', // Fallback to English if translation missing
    ns: ['common', 'login', 'studentUniform', 'sidebar', 'reports', 'userProfile', 'activityManagement', 'dashboard', 'studentMaster', 'userManagement', 'systemAuditLog', 'uniformDataAuditLog', 'issueReports', 'bulkPromotion'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false // Disable suspense for smoother initial render
    }
  });

export default i18n;
